import { render } from "./PropertyListView.vue?vue&type=template&id=4f6e10b2"
import script from "./PropertyListView.vue?vue&type=script&lang=js"
export * from "./PropertyListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__